import { registerGeometryLabel } from '@antv/g2';
import { PieInnerLabel } from './inner-label';

registerGeometryLabel('pie-inner', PieInnerLabel);
